import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.658 2v.75zh-1.044l-2.296.002-2.3.001H7.26l-.213.001h-.082c-1.548.01-2.87.528-3.805 1.499-.932.968-1.409 2.314-1.409 3.854v9.196c0 1.547.481 2.9 1.42 3.87.942.972 2.276 1.487 3.836 1.487v-.75.75H8.05l2.296-.002h3.059l.213-.001h.082a6.2 6.2 0 0 0 1.586-.208 5 5 0 0 1-1.945-1.292l-2.996.002H7.293l-.212.001h-.075l2.999-7.623h4.301q.396-.254.839-.432a.75.75 0 0 0-.68-1.068h-3.87L13.658 3.5c1.224 0 2.144.397 2.759 1.031.618.638.998 1.59.998 2.826v4.66a5 5 0 0 1 1.5.363V7.357c0-1.547-.481-2.9-1.42-3.87C16.551 2.516 15.217 2 13.657 2m-3.063 9.287-.59 1.5zm0 0h-3.35a.75.75 0 0 0 0 1.5h2.76L7.006 20.41c-1.224 0-2.144-.397-2.758-1.031-.618-.638-.998-1.59-.998-2.826V7.357c0-1.23.377-2.177.99-2.814.61-.633 1.52-1.031 2.732-1.039l3.346-.002 2.297-.001h.756l.213-.001h.074zM7.245 7.11a.75.75 0 1 0 0 1.5h2.756a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17 12a5 5 0 1 1 0 10 5 5 0 0 1 0-10",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m19.162 15.559-2.883 2.883L14.838 17"
    }, null, -1)
  ]))]))
}
export default { render: render }